/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Corps d'une correction de ligne : position de colonne -> nouvelle valeur. Seules les cellules corrigées sont envoyées.
 */
export interface ImportLinePatchDto {
    values?: { [key: string]: string; };
}
